module.exports = __webpack_public_path__ + "static/media/404-error.f3b213cc.svg";